import { BranchActions, BRANCH_ACTION_TYPE } from './branch-type';
import { RootState } from '../../../../redux/root-reducer';

export enum BRANCH_STATE_KEY {
  BRANCH_LIST = 'branch_list',
  VAT_LIST = 'vat_list',
  MAPPING_LIST = 'mapping_list',
  ALERT_SUCCESS = 'alert_success',
  ALERT_FAIL = 'alert_fail'
}

export type BranchState = {
  [BRANCH_STATE_KEY.BRANCH_LIST]?: [],
  [BRANCH_STATE_KEY.VAT_LIST]?: [],
  [BRANCH_STATE_KEY.MAPPING_LIST]?: [],
  [BRANCH_STATE_KEY.ALERT_SUCCESS]?: boolean,
  [BRANCH_STATE_KEY.ALERT_FAIL]?: boolean
};

const initialState: BranchState = {
  [BRANCH_STATE_KEY.BRANCH_LIST]: [],
  [BRANCH_STATE_KEY.VAT_LIST]: [],
  [BRANCH_STATE_KEY.MAPPING_LIST]: [],
  [BRANCH_STATE_KEY.ALERT_SUCCESS]: false,
  [BRANCH_STATE_KEY.ALERT_FAIL]: false
};

export const branchReducers = (state = initialState, action: BranchActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case BRANCH_ACTION_TYPE.SET_BRANCH_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const branchStateSelector = (key: BRANCH_STATE_KEY) => (state: RootState) => state.branch[key];
